import { Component, HostListener } from "@angular/core";
import { AppSettings } from "./app.settings";
import { Settings } from "./app.settings.model";
import { Spinkit } from "ng-http-loader";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "./pages/services/auth-services.service";
import { MixinFunctionsService } from "./pages/services/mixin-functions.service";
import { Router } from "@angular/router";
import { LoginComponent } from "./pages/login/login.component";
import { Observable, Subject, timer } from "rxjs";
import { takeUntil } from "rxjs/operators";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  providers: [MixinFunctionsService],
})
export class AppComponent {
  public settings: Settings;
  public spinkit = Spinkit;
  language: string;
  timeOut: boolean;
  constructor(
    public appSettings: AppSettings,
    public translate: TranslateService,
    private auth: AuthService,
    public mixins: MixinFunctionsService,
    public router: Router
  ) {
    this.auth.authRole();

    translate.addLangs(["en", "sw"]);
    translate.setDefaultLang("en");
    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|sw/) ? browserLang : "en");
    this.language = JSON.parse(localStorage.getItem("lang"));
    if (this.language) {
      translate.setDefaultLang(this.language);
    } else {
      translate.setDefaultLang("en");
    }

    this.settings = this.appSettings.settings;
    this.mixins;
  }
  destroy = new Subject();
  showDialog = false;
  timer: number;
  dialog = "stay logged in?";
  notice = "session expired";
  showNotice = false;

  rxjsTimer = timer(1000, 1000);
  ngOnInit() {
    this.resetTimer();
    //this.checkSessionTimer();
  }

  time: any;

  @HostListener("document:mousemove")
  @HostListener("document:keypress")
  @HostListener("document:click")
  @HostListener("document:wheel")
  resetTimer() {
    clearTimeout(this.time);
    this.time = setTimeout((data) => {
      this.timeOut = false;

      if (this.auth.hasSession && this.timeOut === false) {
        this.destroy.next();
        this.destroy.complete();
        this.timeOut = true;
        this.auth.openSessionDialog();
      }
    }, 1000 * 60 * 20);
  }
}
